// extracted by mini-css-extract-plugin
export default {"wrapper":"LockedBundleLabel_wrapper","lockedBundleTimer":"LockedBundleLabel_lockedBundleTimer","content":"LockedBundleLabel_content","icon":"LockedBundleLabel_icon"};